import { t } from '@procumi/shared';
export function Loading({ text = t('Se încarcă…') }: { text?: string }) {
  return <div className="sheet empty">{text}</div>;
}

export function ErrorBox({ error, onRetry }: { error: string; onRetry?: () => void }) {
  return (
    <div className="sheet empty">
      {error}
      {onRetry ? (
        <>
          <br />
          <button className="btn small" style={{ marginTop: 10 }} onClick={onRetry}>
            {t('Încearcă din nou')}
          </button>
        </>
      ) : null}
    </div>
  );
}
